import React from "react";
import {css, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, display, mb, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {ArticleContainer} from "../ArticleContainer";

const ebook20questions465x719 = require("./assets/ebook_20_questions_465x719.png");
const ebookPayingDebt465x719 = require("./assets/ebook_paying_debt_465x719.png");
const ebookABC465x719 = require("./assets/ebook_abc_465x719.png");
const ebookGuide465x719 = require("./assets/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym_465x719.png");

const ebook20questionsPDF = "/static-rp/pdf/rebranding/20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf";
const ebookPayingDebtPDF = "/static-rp/pdf/rebranding/ebook_20_bledow_przy_zakupie_mieszkania_v2.pdf";
const ebookABCPDF = "/static-rp/pdf/rebranding/ABC_ebook_RP_new_2.pdf";
const ebookGuidePDF = "/static-rp/pdf/rebranding/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym.pdf";

interface IEbookSectionProps {
    className?: string;
}

export const EbookSection = (props: IEbookSectionProps) => {
    const theme = useTheme();
    return (
        <section className={props.className} css={[backgroundColor(theme.colors.background[200]), p(3, 0, 5, 0), onDesktop(p(5, 0, 9, 0))]}>
            <ArticleContainer>
                <Text variant="headline_4" as="div">
                    Pobierz darmowe e-booki
                </Text>
                <Text css={mb(4)} variant="body_copy_0" as="div">
                    Poszerz swoją wiedzę o zakupie mieszkania
                </Text>

                <div css={ebookListing}>
                    <EbookCard source={ebookGuide465x719} title="Jak kupić mieszkanie na Rynku Pierwotnym" downloadURL={ebookGuidePDF} />
                    <EbookCard source={ebook20questions465x719} title="20 pytań - darmowy ebook" downloadURL={ebookPayingDebtPDF} />
                    <EbookCard
                        source={ebookPayingDebt465x719}
                        title="sposób na poprawę zdolności kredytowej - darmowy ebook"
                        downloadURL={ebook20questionsPDF}
                    />
                    <EbookCard source={ebookABC465x719} title="abc kupna mieszkania - darmowy ebook" downloadURL={ebookABCPDF} />
                </div>
            </ArticleContainer>
        </section>
    );
};

const ebookListing = css`
    display: flex;
    flex-direction: column;
    row-gap: 2.4rem;

    ${onDesktop(css`
        justify-content: space-between;
        flex-direction: row;
        column-gap: 2.4rem;
    `)};
`;

interface IEbookCardProps {
    title: string;
    source: string;
    downloadURL: string;
}

const EbookCard = (props: IEbookCardProps) => {
    const {source, title, downloadURL} = props;
    const target = useResponsiveLinkTarget();

    return (
        <a css={[display("block"), w100]} href={downloadURL} target={target}>
            <Image css={pdfImg} src={source} alt={title} height="719px" width="465px" ratio={{xs: "465/719"}} />
        </a>
    );
};

const pdfImg = css`
    max-width: 32rem;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    ${elevation(2)};

    ${onDesktop(css`
        max-width: 46.5rem;
    `)}
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, display, mb, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {ArticleContainer} from "../ArticleContainer";

const ebook20questions465x719 = require("./assets/ebook_20_questions_465x719.png");
const ebookPayingDebt465x719 = require("./assets/ebook_paying_debt_465x719.png");
const ebookABC465x719 = require("./assets/ebook_abc_465x719.png");
const ebookGuide465x719 = require("./assets/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym_465x719.png");

const ebook20questionsPDF = "/static-rp/pdf/rebranding/20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf";
const ebookPayingDebtPDF = "/static-rp/pdf/rebranding/ebook_20_bledow_przy_zakupie_mieszkania_v2.pdf";
const ebookABCPDF = "/static-rp/pdf/rebranding/ABC_ebook_RP_new_2.pdf";
const ebookGuidePDF = "/static-rp/pdf/rebranding/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym.pdf";

interface IEbookSectionProps {
    className?: string;
}

export const EbookSection = (props: IEbookSectionProps) => {
    const theme = useTheme();
    return (
        <section className={props.className} css={[backgroundColor(theme.colors.background[200]), p(3, 0, 5, 0), onDesktop(p(5, 0, 9, 0))]}>
            <ArticleContainer>
                <Text variant="headline_4" as="div">
                    Pobierz darmowe e-booki
                </Text>
                <Text css={mb(4)} variant="body_copy_0" as="div">
                    Poszerz swoją wiedzę o zakupie mieszkania
                </Text>

                <div css={ebookListing}>
                    <EbookCard source={ebookGuide465x719} title="Jak kupić mieszkanie na Rynku Pierwotnym" downloadURL={ebookGuidePDF} />
                    <EbookCard source={ebook20questions465x719} title="20 pytań - darmowy ebook" downloadURL={ebookPayingDebtPDF} />
                    <EbookCard
                        source={ebookPayingDebt465x719}
                        title="sposób na poprawę zdolności kredytowej - darmowy ebook"
                        downloadURL={ebook20questionsPDF}
                    />
                    <EbookCard source={ebookABC465x719} title="abc kupna mieszkania - darmowy ebook" downloadURL={ebookABCPDF} />
                </div>
            </ArticleContainer>
        </section>
    );
};

const ebookListing = css`
    display: flex;
    flex-direction: column;
    row-gap: 2.4rem;

    ${onDesktop(css`
        justify-content: space-between;
        flex-direction: row;
        column-gap: 2.4rem;
    `)};
`;

interface IEbookCardProps {
    title: string;
    source: string;
    downloadURL: string;
}

const EbookCard = (props: IEbookCardProps) => {
    const {source, title, downloadURL} = props;
    const target = useResponsiveLinkTarget();

    return (
        <a css={[display("block"), w100]} href={downloadURL} target={target}>
            <Image css={pdfImg} src={source} alt={title} height="719px" width="465px" ratio={{xs: "465/719"}} />
        </a>
    );
};

const pdfImg = css`
    max-width: 32rem;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    ${elevation(2)};

    ${onDesktop(css`
        max-width: 46.5rem;
    `)}
`;
